import {
    CHANGE_LOCALE,
    FONT_SIZE_CHANGE,
    HEADER_HEIGHT,
    IS_MOBILE_CHANGE,
    LOAD_THEME,
    MARGIN_CHANGE,
    MODE_CHANGE,
    NAV_TYPE_CHANGE,
    TABLE_SIZE_CHANGE,
    TOGGLE_COLLAPSED_NAV,
    TOGGLE_MOBILE_NAV
} from '../constants/Theme';
import {ITheme} from "../../model/interface/security/ITheme";

export function toggleCollapsedNav(navCollapsed: boolean) {
  return {
    type: TOGGLE_COLLAPSED_NAV,
    navCollapsed
  };
}

// export function onNavStyleChange(sideNavTheme) {
//   return {
//     type: SIDE_NAV_STYLE_CHANGE,
//     sideNavTheme
//   };
// }

export function onLocaleChange(locale: string) {
  return {
    type: CHANGE_LOCALE,
    locale
  };
}

export function onNavTypeChange(navType: string) {
  return {
    type: NAV_TYPE_CHANGE,
    navType
  };
}

// export function onTopNavColorChange(topNavColor) {
//   return {
//     type: TOP_NAV_COLOR_CHANGE,
//     topNavColor
//   };
// }
//
// export function onHeaderNavColorChange(headerNavColor) {
//   return {
//     type: HEADER_NAV_COLOR_CHANGE,
//     headerNavColor
//   };
// }

export function onIsMobileChange(isMobile: boolean) {
  return {
    type: IS_MOBILE_CHANGE,
    isMobile
  };
}

export function onModeChange(mode: string) {
  return {
    type: MODE_CHANGE,
    mode
  };
}

export function setHeaderHeight(headerHeight: number) {
  return {
    type: HEADER_HEIGHT,
    headerHeight
  };
}

export function onMobileNavToggle(mobileNav: boolean) {
  return {
    type: TOGGLE_MOBILE_NAV,
    mobileNav
  };
}

// export function onSwitchTheme(currentTheme: string) {
//   return {
//     type: SWITCH_THEME,
//     currentTheme
//   };
// }

// export function onDirectionChange(direction: string) {
//   return {
//     type: DIRECTION_CHANGE,
//     direction
//   };
// }


export function onMarginChange(margin: string) {
  return {
    type: MARGIN_CHANGE,
    margin
  };
}

export function onFontSizeChange(fontSize: string) {
  return {
    type: FONT_SIZE_CHANGE,
    fontSize
  };
}

export function onTableSizeChange(tableSize: string) {
  return {
    type: TABLE_SIZE_CHANGE,
    tableSize
  };
}

export function loadTheme(theme: ITheme) {
  return {
    type: LOAD_THEME,
    theme
  };
}

export default {
  toggleCollapsedNav,
  // onNavStyleChange,
  onLocaleChange,
  onIsMobileChange,
  // onNavTypeChange,
  // onTopNavColorChange,
  // onHeaderNavColorChange,
  onMobileNavToggle,
  // onSwitchTheme,
  // onDirectionChange
  onMarginChange,
  onFontSizeChange,
  onTableSizeChange,
  setHeaderHeight,
  loadTheme,
}
